import Vue from "vue";

// Hacky way to manipulate carousel accessibility without forking and maintaining the project
export default Vue.extend( {
  mounted () {
    this.checkCarouselSlideTabIndexes();
  },
  methods: {
    checkCarouselSlideTabIndexes () {
      const carouselSlides = Array.from( document.getElementsByClassName( "VueCarousel-slide" ) );

      for ( let i = 0; carouselSlides.length > i; i += 1 ) {
        // accessible name for elements with role="tabpanel"
        carouselSlides[i].ariaLabel = "Carousel slide";
        const { ariaHidden } = carouselSlides[i];
        const tabIndex = ariaHidden ? "-1" : "0";

        this.setChildActionTabIndexes( carouselSlides[i], tabIndex );
      }
    },
    setChildActionTabIndexes ( node, tabIndex ) {
      for ( let i = 0; i < node.childNodes.length; i += 1 ) {
        const child = node.childNodes[i];
        this.setChildActionTabIndexes( child, tabIndex );

        if ( child.nodeName === "A" || child.nodeName === "BUTTON" ) {
          // eslint-disable-next-line
          // element "A or "BUTTON" should not be focusable within the subtree of an element with aria-hidden: true
          child.tabIndex = tabIndex;
        }
      }
    }
  }
} );
